export default defineNuxtPlugin({
  setup() {
    // manually add the script to the DOM
    const script = document.createElement('script')
    script.src = '/js/access.js'
    script.async = true
    document.head.appendChild(script)
  },
})
